//#region src/error.ts
var ShikiError = class extends Error {
	constructor(message) {
		super(message);
		this.name = "ShikiError";
	}
};

//#endregion
export { ShikiError };